import { useEffect } from 'react'

import ConfirmDialog from '../../../components/ReusableComponents/ConfirmationDialog'
import useCustomSearch from '../../../hooks/useCustomSearch'

const TripAdvisorURLDialog = ({ subsidiaryName, handleHideDialog }) => {
  useEffect(() => {
    document.body.classList.add('dialog-open')
    return () => {
      document.body.classList.remove('dialog-open')
    }
  }, [])

  const [openTA, closeTA] = useCustomSearch('TA', handleTAURL)

  function handleButtonClick() {
    openTA(subsidiaryName)
  }

  function handleTAURL(url) {
    const [g, d] = /(g\d*)-(d\d*)/g.exec(url)

    handleHideDialog(d, g)
    closeTA()
  }

  return (
    <ConfirmDialog
      title="TripAdvisor link is missing"
      positiveMessage="Set up with one click"
      hasNegativeMessage={false}
      onConfirm={handleButtonClick}
      onClose={handleHideDialog}
    >
      <p>
        In order to enable reviews, we need the review link of your hotel. Follow these
        simple instructions to add your link.
      </p>
    </ConfirmDialog>
  )
}

export default TripAdvisorURLDialog
